import { defineStore } from 'pinia'

// Aplica/quita la clase 'dark' en <html> (estrategia darkMode: 'class' de Tailwind)
// y ajusta el theme-color, que tiñe la barra de estado en la PWA de iOS/Android.
function applyDark(on) {
  document.documentElement.classList.toggle('dark', on)
  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) meta.setAttribute('content', on ? '#0f172a' : '#ffffff')
}

// Preferencias de interfaz (persistidas en el navegador).
export const useUiStore = defineStore('ui', {
  state: () => ({
    hideAmounts: localStorage.getItem('hideAmounts') === '1',
    darkMode: localStorage.getItem('darkMode') === '1',
  }),
  actions: {
    toggleAmounts() {
      this.hideAmounts = !this.hideAmounts
      localStorage.setItem('hideAmounts', this.hideAmounts ? '1' : '0')
    },

    setDark(on) {
      this.darkMode = on
      localStorage.setItem('darkMode', on ? '1' : '0')
      applyDark(on)
    },
    toggleDark() {
      this.setDark(!this.darkMode)
    },
    // Aplica el tema guardado al arrancar la app.
    initTheme() {
      applyDark(this.darkMode)
    },
  },
})
